import CustomTypography from "@/components/Typography/CustomTypography";
import dayjs from "dayjs";

export default function TableCellWithTime({
  value,
  className,
  format,
}: {
  value: string;
  className?: string;
  format?: string;
}) {
  return (
    <div>
      <CustomTypography
        as="span"
        weight={"light"}
        className={["text-nowrap", className].join(" ")}
      >
        {dayjs(value).format(format ? format : "DD.MM.YYYY, hh:mm A")}
      </CustomTypography>
    </div>
  );
}
